import cardOffers from 'html/layouts/card-offers.html';
import App from 'app/app.js';
import 'app/directive/LtCardOffersCtrl.js';

function LtCardOffersDirective() {
  return {
    restrict: 'E',
    scope: {
      bannerView: '<',
      onChange: '&'
    },
    template: cardOffers,
    controller: 'LtCardOffersCtrl',
    controllerAs: 'cardOffers'
  };
}

App.directive('ltCardOffers', [LtCardOffersDirective]);
